import { useEffect, useState } from 'react'
import BaseInput from '../../components/inputs/BaseInput'
import LinkButton from '../../components/inputs/LinkButton'
import { useInfo } from '../../context/useInfo';
import { Link, useLocation } from 'react-router';

function DashboardCreateTag() {
  const { info, fetchWeb } = useInfo();
  if (info == null) return <></>

  const location = useLocation();
  const editState = location.state || {}

  const [responseMessage, setResponseMesage] = useState<null | { message: string, path: string, error?: string }>(null);
  const [tagData, setTagData] = useState<{ id?: number, name: string, description: string }>({
    id: editState['id'],
    name: editState['name'] || "",
    description: editState['description'] || ""
  })

  useEffect(() => {
    if (responseMessage === null) return;

    const timeoutID = setTimeout(() => {
      setResponseMesage(null)
    }, 10000)

    return () => {
      clearTimeout(timeoutID)
    }
  }, [responseMessage])

  async function postCategory() {
    const response = await fetchWeb('/wiki/categories', {
      method: tagData.id ? "PATCH" : "POST",
      data: {
        id: tagData.id,
        name: tagData.name,
        description: tagData.description,
      }
    })

    if (response && response['msg'] == undefined) {
      setResponseMesage({
        path: `/tag/${tagData.name}`,
        message: "Tag successfully created, click here to redirect"
      })
      setTagData({ name: "", description: "" })
      return
    }

    setResponseMesage({
      path: `#`,
      message: "",
      error: response ? response['msg'] : "Something happened while uploading the category..."
    })
  }

  return <>
    {responseMessage && <Link
      to={responseMessage.path}
      className={
        'text-white font-semibold block p-2 px-4 w-[calc(100%_+_2rem)] -m-4 mb-8 ' +
        (responseMessage.error ? 'bg-red-600' : 'bg-radiationGreen')
      }
      children={responseMessage.error ? responseMessage.error : responseMessage.message}
    />}
    <div className='mb-4'>
      <img src="/images/paper_and_pencil.png" alt="paper and pencil icon" className='inline w-16 aspect-square mr-4' />
      <h2 className='inline text-3xl font-semibold mb-2 align-middle' children={`${tagData.id ? "Update": "Create"} category/tag`} />
    </div>

    <div>
      <span className='block'>Name</span>
      <BaseInput
        value={tagData.name}
        onChange={({ target }) => setTagData(last => ({ ...last, name: target.value }))}
        placeholder='example: Andec Reactor'
        className='w-full'
      />
    </div>
    <div className='mt-2'>
      <span className='block'>Description</span>
      <BaseInput
        value={tagData.description}
        onChange={({ target }) => setTagData(last => ({ ...last, description: target.value }))}
        placeholder="example: Game made in roblox"
        className='w-full'
      />
    </div>
    <div className='flex flex-wrap *:flex-grow gap-2 mt-4'>
      <LinkButton children="Cancel" selected={false} to={tagData.id ? `/tag/${tagData.name}` : "/dashboard"} />
      <LinkButton children={tagData.id ? "Update tag" : "Create tag"} onClick={postCategory} />
    </div>
  </>
}

export default DashboardCreateTag